import React, { useContext, useState, useEffect } from "react";
import { StepperContext } from "../context/StepperContext";
import Select from "react-select";
import { db } from "../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import "../style.css";

export default function ArtInfo() {
  /**the state used to store inputs values of the post**/
  const { postData, setPostData } = useContext(StepperContext);
  const [cats, setCats] = useState([]);

  /**fetching the categories from db**/
  const fetchCats = async () => {
    const catRef = collection(db, "categories");
    getDocs(catRef).then((response) => {
      const categories = response.docs.map((doc) => ({
        data: doc.data(),
        id: doc.id,
      }));
      setCats(categories);
    });
  };

  useEffect(() => {
    fetchCats();
  }, []);

  /**select options**/
  const options = [];

  /**pushing fetching results as options in the array**/
  for (let i = 0; i < cats.length; i++) {
    options.push({
      label: cats[i].data.categoryName,
      value: cats[i].data.categoryName,
    });
  }

  /**overwriting default styles of the react-select**/
  const customStyles = {
    /**overwrite the text color of the the input**/
    singleValue: (base) => ({ ...base, color: "white" }),
    control: (base, state) => ({
      ...base,
      background: "rgb(39 39 42)",
      // Overwrites the focus state of border
      borderColor: state.isFocused ? "#D0AA87" : "#101010",
      // Removes border around container
      boxShadow: state.isFocused ? null : null,
      // overwites the selected option diplayed in the input
      "&:hover": {
        // Overwrites the hover state of border
        borderColor: state.isFocused ? "#D0AA87" : "#D0AA87",
      },
    }),
    option: (styles, { isDisabled, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "red" : "rgb(39 39 42)",
        backgroundColor: isSelected ? "#212121" : "rgb(39 39 42)",
        color: isSelected ? "#fff" : "#fff",
        cursor: isDisabled ? "not-allowed" : "pointer",
        "&:hover": {
          background: "#212121",
        },
      };
    },
  };

  return (
    <div className="w-full h-[85%]">
      {options && (
        <form className="form-control w-full h-[95%] px-8 pt-5 flex flex-col justify-between">
          <div className="inputContainer">
            <label className="label" htmlFor="title">
              <span className="label-text text-inputLabel font-bold text-sm">
                Article's title
              </span>
            </label>
            <input
              defaultValue={postData.title}
              type="text"
              placeholder="Type here"
              name="title"
              className="inputStyle capitalize bg-zinc-800 placeholder:text-zinc-600"
              onChange={(e) =>
                setPostData({ ...postData, title: e.target.value })
              }
            />
          </div>
          <div className="inputContainer">
            <label className="label" htmlFor="caption">
              <span className="label-text text-inputLabel font-bold text-sm">
                Article's caption
              </span>
            </label>
            <input
              defaultValue={postData.caption}
              type="text"
              placeholder="Type here"
              className="inputStyle bg-zinc-800 placeholder:text-zinc-600"
              name="caption"
              onChange={(e) =>
                setPostData({ ...postData, caption: e.target.value })
              }
            />
          </div>
          <div className="inputContainer">
            <label className="label">
              <span className="label-text text-inputLabel font-bold text-sm">
                Category
              </span>
            </label>
            <div className="mt-0">
              <Select
                styles={customStyles}
                options={options}
                placeholder="Choose a category..."
                name="category"
                onChange={(e) =>
                  setPostData({ ...postData, category: e.value })
                }
              />
              {postData.category && (
                <span className="text-xs text-gray-300">
                  you've chosen{" "}
                  <span className="text-blue-500">{postData.category}</span>
                </span>
              )}
            </div>
          </div>
        </form>
      )}
      <h6 className="flex w-full flex-row justify-end pr-10 text-xs mt-5 text-red-400">
        * the title and category fields are required
      </h6>
    </div>
  );
}
